import Abank24 from './views/pension.c';
export default Abank24;
